import React, { Component } from "react";
import SingleEnemyCard from "../table/SingleEnemyCard";
import { Divider, Row, Layout, Popover, Icon } from "antd";
import ReactGA from "react-ga4";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import axios from "axios";
import VenatusAd from "../ads/VenatusAd";
import VenatusAdWithPlaceholder from "../ads/VenatusAdWithPlaceholder";
import {
  VENATUS_DESKTOP_SIDE_RAIL,
  VENATUS_DESKTOP_MULTISIZE_LEADERBOARD,
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_MOBILE_LEADERBOARD,
  VENATUS_MOBILE_INCONTENT,
  VENATUS_RICH_MEDIA,
} from "../utilities/constants";

const { Content } = Layout;

// const SampleEnemy = {
//   sampledata: {
//     hp: 1222222,
//     kb: 10,
//     speed: 40,
//     atk: 44000,
//     atk_recoil: 0,
//     range: 320,
//     money: 4444,
//     unknown_1: 0,
//     hitbox_width: 320,
//     unknown_2: 0,
//     red: true,
//     att_type: "1",
//     pre_atk_anim: 5,
//     floating: false,
//     black: true,
//     metal: false,
//     white: false,
//     angel: false,
//     alien: false,
//     zombie: true,
//     knockback_chance: 0,
//     freeze_chance: 0,
//     freeze_duration: 0,
//     slow_chance: 0,
//     slow_duration: 0,
//     critical_chance: 0,
//     basedestroyer: 0,
//     waveattack_chance: 0,
//     waveattack_level: 0,
//     weaken_chance: 0,
//     weaken_duration: 0,
//     weaken_amount: 0,
//     strengthen_hpleft: 0,
//     strengthen_amount: 0,
//     survive_chance: 0,
//     longdistance_minrange: 0,
//     longdistance_maxrange: 0,
//     wave_immune: false,
//     unknown_3: false,
//     knockback_immune: false,
//     freeze_immune: false,
//     slow_immune: false,
//     weaken_immune: false,
//     burrow_count: 0,
//     burrow_dist: 0,
//     revive_count: 0,
//     revive_time: 0,
//     revive_hp: 0,
//     witch: false,
//     dojo_base: false,
//     attacksonce: -1,
//     unknown_4: -1,
//     unknown_5: 0,
//     unknown_6: -1,
//     death_anim: 0,
//     atk_2: 222,
//     atk_3: 222,
//     pre_atk_2: 10,
//     pre_atk_3: 20,
//     ability_1: 1,
//     ability_2: 1,
//     ability_3: 1,
//     unknown_7: false,
//     unknown_8: false,
//     barrier: 0,
//     warp_chance: 0,
//     warp_duration: 0,
//     warpdistance_minrange: 0,
//     warpdistance_maxrange: 0,
//     star_alien: 0,
//     resist_warp: false,
//     eva: false,
//     relic: false,
//     curse_chance: 0,
//     curse_duration: 0,
//     savage_blow_chance: 0,
//     savage_blow_amount: 0,
//     dodge_chance: 0,
//     dodge_duration: 0,
//     toxic_chance: 0,
//     toxic_duration: 0,
//     surge_chance: 0,
//     surge_minrange: 0,
//     surge_maxrange: 0,
//     surge_level: 0,
//     angry_sun: false,
//     mini_wave: false,
//     fullswing_anim: 35,
//     enemy_name_en: "Raging Bahamut Cat",
//     enemy_name_jp: "暴走のネコムート",
//     enemy_no: 212,
//     backswing_anim: 15,
//     time_btw_att: 35,
//     real_tba: 35,
//     dps: 38095,
//     omnistrike: false,
//     multihitattack_number: 3,
//     special_att_desc:
//       "u1Offensive abilitiesu2: b1Multi-hit attackb2 (Attacks thrice)",
//   },
// };

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com:5000/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
  
};

class SingleEnemy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
      selectedEnemy: [],
    };
  }

  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    const { enemy_name_en } = this.props.match.params;

    document.title =
      this.props.match.params.enemy_name_en +
      " | Battle Cats Wiki for Cat Stats";

    axios
      .post("https://onestoppress.com/api/singleenemy", {
        compare: enemy_name_en.toString(),
      })
      .then((res) => {
        let enemyone = res.data.sampledata;
        if (res.data.hasOwnProperty("sampledata")) {
          this.setState({
            selectedEnemy: enemyone,
          });
        }
      });

    // this.setState({ selectedEnemy: SampleEnemy.sampledata });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 636) {
      adjustViewport = 22;
    } else if (window.innerWidth < 948) {
      adjustViewport = 34;
    } else {
      adjustViewport = 46;
    }
    this.setState({
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  render() {
    const cardWidth =
      this.props.viewportWidth > 948
        ? this.props.viewportWidth / 3 - 4
        : this.props.viewportWidth > 636
        ? this.props.viewportWidth / 2 - 6
        : this.props.viewportWidth - 24;

    const { mult } = this.props.match.params;
    const URLmult = mult > 0 && mult < 500000 ? mult : 100;

    return (
      <div>
        <div className="pagetitle">
          <h1
            style={{
              padding: "10px 0 0 0",
              marginBottom: "6px",
              maxWidth: this.state.viewportWidth - 104,
              float: "left",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
          >
            Enemy Info
          </h1>
          <div style={{ paddingTop: "10px" }}>
            <Popover
              content={<div>Credit to BCU for the enemy ability icons</div>}
              placement="bottomRight"
            >
              <Icon type="info-circle" />
            </Popover>
          </div>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
          {this.state.viewportWidth > 1024 ? (
            <VenatusAdWithPlaceholder placementId={VENATUS_DESKTOP_LEADERBOARD} />
          ) : (
            <VenatusAdWithPlaceholder placementId={VENATUS_MOBILE_LEADERBOARD} />
          )}
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content style={{ padding: "0 0px" }} className="flexible-width">
            <div
            >
              <Row style={{ padding: "16px 0 0px 0" }}>
                <SingleEnemyCard
                  viewportWidth={this.state.viewportWidth}
                  selectedEnemy={this.state.selectedEnemy}
                  multiplier={URLmult}
                />
                <div
                  style={{
                    padding: "4px",
                    minWidth: "350px",
                    maxWidth: "400px",
                    height: "550px !important",
                    width: cardWidth,
                    display: "inline-block",
                    verticalAlign: "top",
                  }}
                  className="mobile-hide"
                >
                  {
                    // <VerticalAdComponent
                    //   dataAdClient="ca-pub-1920730948516638"
                    //   dataAdSlot="2391245848"
                    // />
                    this.state.viewportWidth > 1024 ? (
                      <span>
                      <VenatusAdWithPlaceholder placementId={VENATUS_DESKTOP_SIDE_RAIL} />
                      </span>
                    ) : (
                      <VenatusAdWithPlaceholder placementId={VENATUS_MOBILE_INCONTENT} />
                    )
                  }
                </div>
              </Row>
            </div>
          </Content>
        </Layout>
        {this.state.viewportWidth > 1024 ? (
          <VenatusAdWithPlaceholder placementId={VENATUS_DESKTOP_MULTISIZE_LEADERBOARD} />
        ) : (
          ""
        )}
        <div>
          <VenatusAd
            placementId={VENATUS_RICH_MEDIA}
            style={{ display: "none" }}
          />
        </div>
        {/* <div id="waldo-tag-14678"></div> */}
      </div>
    );
  }
}

export default SingleEnemy;

SingleEnemy.propTypes = {
  applyViewportChange: PropTypes.number,
};

SingleEnemy.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components/content/SingleEnemy.js